export class EmploymentInfo {
  constructor(employerName = '', yearsEmployed = null, monthsEmployed = null, jobDescription = '', activeIncomeVerification = null) {
    this.employerName = employerName;
    this.yearsEmployed = yearsEmployed;
    this.monthsEmployed = monthsEmployed;
    this.jobDescription = jobDescription;
    this.activeIncomeVerification = activeIncomeVerification;
  }
}

export class CurrentAddress {
  constructor(street = '', aptNumber = null, city = '', stateCode = '', zipCode = '') {
    this.street = street;
    this.aptNumber = aptNumber;
    this.city = city;
    this.stateCode = stateCode;
    this.zipCode = zipCode;
  }
}

export class Applicant {
  constructor(
    firstName = '',
    lastName = '',
    emailAddress = '',
    confirmEmailAddress = '',
    phoneNumber = '',
    phoneType = null,
    smsOptIn = false,
    currentAddress = new CurrentAddress(),
    currentAddressType = 'other',
    ssn = '',
    dateOfBirth = '',
    employmentStatus = '',
    employmentInfo = new EmploymentInfo(),
    incomeAmount = null,
    otherIncome = null,
    profileReferenceId = '',
    prospectId = '',
    externalId = '',
    clientCorrelationId = '',
    isSameAddress = null,
    lastFourTaxId = '',
  ) {
    this.lastName = lastName;
    this.firstName = firstName;
    this.emailAddress = emailAddress;
    this.confirmEmailAddress = confirmEmailAddress;
    this.phoneNumber = phoneNumber;
    this.phoneType = phoneType;
    this.smsOptIn = smsOptIn;
    this.currentAddress = currentAddress;
    this.currentAddressType = currentAddressType;
    this.ssn = ssn;
    this.dateOfBirth = dateOfBirth;
    this.employmentStatus = employmentStatus;
    this.employmentInfo = employmentInfo;
    this.incomeAmount = incomeAmount;
    this.otherIncome = otherIncome;
    this.profileReferenceId = profileReferenceId;
    this.prospectId = prospectId;
    this.externalId = externalId;
    this.clientCorrelationId = clientCorrelationId;
    this.isSameAddress = isSameAddress;
    this.lastFourTaxId = lastFourTaxId;
  }
}

export class Application {
  constructor(
    loanType = 'REFINANCE',
    applicationType = 'INDIVIDUAL',
    profileType = 'financial',
    agreeToLookup = null,
    agreeToTerms = null,
    primaryApplicant = new Applicant(),
    coApplicant = new Applicant(),
    promoCode = '',
    selectedVehicle = null,
    manualEntryFlag = null,
    selectedLoan = null,
    isNewApp = false,
    applicationReferenceId = '',
  ) {
    this.loanType = loanType;
    this.applicationType = applicationType;
    this.profileType = profileType;
    this.primaryApplicant = primaryApplicant;
    this.coApplicant = coApplicant;
    this.promoCode = promoCode;
    this.agreeToTerms = agreeToTerms;
    this.agreeToLookup = agreeToLookup;
    this.selectedVehicle = selectedVehicle;
    this.manualEntryFlag = manualEntryFlag;
    this.selectedLoan = selectedLoan;
    this.isNewApp = isNewApp;
    this.applicationReferenceId = applicationReferenceId;
  }
}
